export default "__VITE_PUBLIC_ASSET__612be354__"